<template>
  <div>

    <template v-if="regions.length > 0">
      <div class="location-items">
        <div class="col-12 col-md-6 pointer" v-for="country in filterData.country">

          <div class="location-items-group">

            <div class="col-1 select-item">
              <label class="custom-label">
                <input type="checkbox" name="filter_country"
                       :checked="filterData.region.some(c => c.type === 'country' && c.id_country === country.id )"
                       @change="toggleMultipleRegionCountry('region', {type: 'country', id: country.code, id_country: country.id, count_of_accommodations: country.count_of_accommodations})">

                <span class="checkmark"></span>
              </label>
            </div>

            <div class="col-2 image-item">
              <img :src="`/img/flags/New${country.code.toUpperCase()}.png?v=2`"
                   :alt="country.title"
                   @click="toggleMultipleRegionCountry('region', {type: 'country', id: country.code, id_country: country.id, count_of_accommodations: country.count_of_accommodations})"
                   class="place-img img-cover d-inline-block" width="64" height="64">
            </div>

            <div class="col-8 title-item" @click="toggleMultipleRegionCountry('region', {type: 'country', id: country.code, id_country: country.id, count_of_accommodations: country.count_of_accommodations})">
                <span class="country-title">{{ $t('filter-whole-' + country.title) }}</span>
                <span class="offer-count d-block">{{ country.count_of_accommodations }}</span>
            </div>

          </div>

        </div>
      </div>
      <div class="col-12 py-2"></div>

    </template>

    <div class="location-items">
      <div class="col-12 col-md-6"
           v-for="region in regions.filter(r => !(filterData.region && filterData.region.some(c => c.type ==='country' && c.id_country === r.country.id))).sort((a, b) => Number(a.count_of_accommodations) <= Number(b.count_of_accommodations) ? 1 : -1)">
        <div class="location-items-group">

          <div class="col-1 select-item">
            <div class="custom-label">
              <label class="text-center">
                <input type="checkbox" name="filter_country"
                       :checked="filterData.region.some(c => c.id === region.id)"
                       @change="toggleMultiple('region', region)">

                <span class="checkmark"></span>
              </label>
            </div>
          </div>

          <div class="col-2 image-item">
            <figure>
              <img :src="region.images[0].getTyrionSrc(TyrionResourceImageType.Thumb)"
                   :alt="region.title" @click="toggleMultiple('region', region)"
                   class="img-cover img-atraction" width="64" height="64">
              <img v-if="filterData.country.length > 1"
                   :src="`/img/flags/New${region.country.code.toUpperCase()}.png?v=2`"
                   :alt="region.country.title"
                   class="img-cover img-country-flag" loading="lazy" width="18" height="18">
            </figure>

          </div>

          <div class="col-8 title-item" @click="toggleMultiple('region', region)">

              <span class="countrt-title">{{ region.langtitle[activeLocale.code] ?? region.title }}</span>
              <span class="offer-count d-block">
            {{ region.count_of_accommodations }}
            {{ $t($vysklonujSlovo('ponuk', region.count_of_accommodations, 'y', '', 'a')).toLowerCase() }}
          </span>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import PlaceCountry from "../../../../../lib/models/PlaceCountry";
import PlaceTouristRegion from "../../../../../lib/models/PlaceTouristRegion";
import {useNuxtApp} from "#app";
import {TyrionResourceImageType} from "../../../../../lib/enums/TyrionResourceImageType";
import {IBaseFilterData} from "../../../../../lib/interfaces/IBaseFilterData";

const props = defineProps<{
  countries: Array<PlaceCountry>;
  regions: PlaceTouristRegion[];
  filterData: IBaseFilterData;
  activeLocale: {code: String},
  toggleMultiple: (value: boolean) => void;
}>();

const emit = defineEmits(['nextStep']);

const {$vysklonujSlovo} = useNuxtApp();


const toggleMultipleRegionCountry = (key: string, item: {
  id: number,
  title: string,
  id_country: number | undefined
}) => {

  props.filterData.region = props.filterData.region.filter(r => {
    return r.type !== 'country' && r.country.id != item.id_country || r.type === 'country';
  });
  props.toggleMultiple(key, item);

  if(props.filterData.country.length === 1 && props.filterData.region.some(c => c.type === 'country')){
    emit('nextStep');
  }
}

</script>
